import OzonSeoUniqualization from '../../../../components/OzonSeoUniqualization';

export default OzonSeoUniqualization;
